import { db } from "./firebase";
import { collection, onSnapshot, query, where, getDocs, writeBatch, doc } from "firebase/firestore";

export const onUnreadNotificationsChange = (userId, callback) => {
    const notificationsRef = collection(db, 'users', userId, 'notifications');
    const q = query(notificationsRef, where("read", "==", false));
    
    return onSnapshot(q, (snapshot) => {
        const counts = {};
        snapshot.docs.forEach(doc => {
            const notification = doc.data();
            counts[notification.elementId] = (counts[notification.elementId] || 0) + 1;
        });
        callback(counts);
    }, (error) => {
        console.error("Error listening to notifications:", error);
    });
};

export const markNotificationsAsRead = async (userId, elementId) => {
    const notificationsRef = collection(db, 'users', userId, 'notifications');
    const q = query(notificationsRef, where("elementId", "==", elementId), where("read", "==", false));
    
    const snapshot = await getDocs(q);
    if (snapshot.empty) return;

    const batch = writeBatch(db);
    snapshot.docs.forEach(doc => {
        batch.update(doc.ref, { read: true });
    });

    await batch.commit();
};
